import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import ProfilePic from "./BuckinghamTweeterAssets/Tweeter-ProfilePic.webp";
import Photo1 from "./BuckinghamTweeterAssets/Tweeter-Photo-01.webp";
import Photo2 from "./BuckinghamTweeterAssets/Tweeter-Photo-02.webp";
import Photo3 from "./BuckinghamTweeterAssets/Tweeter-Photo-03.webp";
import Photo4 from "./BuckinghamTweeterAssets/Tweeter-Photo-04.webp";
import Photo5 from "./BuckinghamTweeterAssets/Tweeter-Photo-05.webp";

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

export const BuckinghamTweetContent: Tweet[] = [
  {
    icon: ProfilePic,
    date: "16 Aug 2024",
    time: "3:15 PM",
    author: "The London Herald",
    handle: "@londonherald",
    verified: "Verified.webp",
    content:
      "BREAKING: The Prime Minister announces a new initiative to tackle the cost-of-living crisis, promising 'immediate relief' for families across the UK. 🏠💷 #CostOfLiving #UKPolitics",
    contentImage: Photo1,
    likes: 2100,
    retweets: 41,
    quotes: 0,
  },
  {
    icon: ProfilePic,
    date: "16 Aug 2024",
    time: "2:09 PM",
    author: "The London Herald",
    handle: "@londonherald",
    verified: "Verified.webp",
    content:
      "A rare 16th-century painting discovered in a rural attic has sold at auction for a staggering £12 million. 🎨💰 #ArtNews #HiddenTreasure",
    contentImage: Photo2,
    likes: 1100,
    retweets: 13,
    quotes: 0,
  },
  {
    icon: ProfilePic,
    date: "16 Aug 2024",
    time: "1:13 PM",
    author: "The London Herald",
    handle: "@londonherald",
    verified: "Verified.webp",
    content:
      "The government has announced plans to expand high-speed rail networks, connecting more cities across the UK. 🚄🗺️ #Infrastructure #TransportNews",
    contentImage: Photo3,
    likes: 1900,
    retweets: 44,
    quotes: 0,
  },
  {
    icon: ProfilePic,
    date: "16 Aug 2024",
    time: "12:43 PM",
    author: "The London Herald",
    handle: "@londonherald",
    verified: "Verified.webp",
    content:
      "London's West End is set to welcome a star-studded new production of Hamlet, with tickets already selling out in record time. 🎭🌟 #TheatreNews #WestEnd",
    contentImage: Photo4,
    likes: 1300,
    retweets: 35,
    quotes: 0,
  },
  {
    icon: ProfilePic,
    date: "16 Aug 2024",
    time: "11:19 AM",
    author: "The London Herald",
    handle: "@londonherald",
    verified: "Verified.webp",
    content:
      "Rupert Langsford's rise to the top has been nothing short of meteoric. Love him or loathe him, there's no denying his influence… or his ambition. #BusinessMogul #RupertLangsford",
    contentImage: Photo5,
    likes: 1200,
    retweets: 29,
    quotes: 0,
  },
];
